<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'earthwork'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <autopsy-info :assignment="this.assignment" :propertyTab="'earthwork'"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class = "second-row">
                    <custom-datetime :value="localEarthwork.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localEarthwork.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localEarthwork?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode ? rules: []"
                    @new-comment="onNewComment"
                />
                <material-selection v-if="config.hasStorage" ref="material-selection" :editMode="editMode" :assignmentTab="'earthwork'" :assignment="assignment" />
                <image-section ref="image-section" :uploadedPhotos="this.localEarthwork.photos || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :uploadPath="this.assignment.sr + '/earthwork'" @photoSelection="onPhotoSelection" :title="'Φωτογραφίες'" :zipName="this.assignment.sr + '_' + 'earthwork'"/>
                <v-divider class="mt-5"/>
                <issue-existance-field
                    ref="malfunction-section"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :label="'Βλάβη / Πρόβλημα'"
                    :check="hasMalfunction"
                    :comments="localEarthwork.malfunction?.comments || {}"
                    :uploadedPhotos="localEarthwork.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/earthwork/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
            <waiting-message v-if="waitingMessage" :waiting-message="waitingMessage" />
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import ImageSection from '@/components/ImageSection'
    import FormToolbar from '@/components/FormToolbar'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'
    import IssueExistanceField from '@/components/IssueExistanceField'
    import AutopsyInfo from '@/components/AutopsyInfo'
    import WaitingMessage from '@/components/WaitingMessage'

    export default {
        name: 'EarthworkTab',
        components: { Alert, AutopsyInfo, Comments, CustomDatetime, ImageSection, FormToolbar, MaterialSelection, IssueExistanceField, WaitingMessage },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                },
                deep: true
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                // if (this.hasMalfunction && ((!this.selectedTroublePhotos > 0 && !this.localEarthwork.malfunction.photos) || !this.localEarthwork.malfunction.description)) {
                //     return true
                // }
                if (this.localEarthwork.status === 'FOR_CANCELLING') {
                    return false
                }
                return !((this.localEarthwork.comments || this.newComment) && this.localEarthwork.appointmentDate && this.localEarthwork.status && (this.selectedPhotos > 0 || this.localEarthwork.photos) && this.editMode)
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.earthwork?.statuses || []
            }
        },
        data: () => {
            return {
                localEarthwork: {
                    description: null,
                    photos: []
                },
                hasMalfunction: false,
                newComment: null,
                selectedPhotos: 0,
                selectedTroublePhotos: 0,
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false,
                waitingMessage: null
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            appointmentDateSelected(datetime) {
                this.$set(this.localEarthwork, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            resetForm() {
                this.localEarthwork = {}
                this.localEarthwork = this.assignment.earthwork ? JSON.parse(JSON.stringify(this.assignment.earthwork)) : {}
                this.hasMalfunction = !!this.localEarthwork.malfunction
                if (this.localEarthwork.photos) {
                    this.localEarthwork.photos = [ ...this.localEarthwork.photos ]
                }
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 6000)
            },
            async editAssignment() {
                const coords = await geolocation.getCoordinates()

                this.loading = true
                if (!this.localEarthwork.photos) {
                    this.localEarthwork.photos = []
                }
                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localEarthwork.malfunction = this.localEarthwork.malfunction || { photos: [] }
                    this.localEarthwork.malfunction.newComment = malfunctionSection.newComment
                }
                this.waitingMessage = 'Ανέβασμα Αρχείων...'
                if (this.isAdminOrCompanyCoordinator) {
                    try {
                        const deletedPhotos = await this.$refs['image-section'].deleteUploadedPhotos()
                        this.localEarthwork.photos = deletedPhotos ? this.localEarthwork.photos.filter(photo => !deletedPhotos.includes(photo)) : [ ...this.localEarthwork.photos ]
                        if (this.hasMalfunction) {
                            const deletedTroubleshootingPhotos = await this.$refs['malfunction-section'].deleteUploadedPhotos()
                            this.localEarthwork.malfunction.photos = deletedTroubleshootingPhotos ? this.localEarthwork.malfunction.photos.filter(photo => !deletedTroubleshootingPhotos.includes(photo)) : [ ...this.localEarthwork.malfunction.photos ]
                        }
                    } catch (error) {
                        this.setAlert(error.message, 'error')
                        this.loading = false
                        this.waitingMessage = null
                        return
                    }
                }

                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localEarthwork.photos = uploadedPhotos ? this.localEarthwork.photos.concat(uploadedPhotos) : this.localEarthwork.photos
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localEarthwork.malfunction.photos = uploadedTroubleshootingPhotos ? this.localEarthwork.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localEarthwork.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    this.waitingMessage = null
                    return
                }
                this.localEarthwork.geolocation = coords
                this.localEarthwork.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localEarthwork.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }

                assignmentService.updateAssignmentTab('earthwork', this.assignment.id, { earthwork: this.localEarthwork }).then((response) => {
                    this.switchEditMode(false)
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.$emit('assignment-refresh')
                    this.setAlert('Η ενημέρωση των Χωματουργικών ήταν επιτυχημένη', 'success')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                }).finally(() => {
                    this.waitingMessage = null
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.v-card__title {
    padding: 0 !important;
}

.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.edit-button-wrapper {
    display: flex;
    justify-content: flex-start;
}

.field.status {
    min-width: 300px;
    max-width: 50%;
}

/* .field-comment {
    pointer-events: none;
} */
.field.completed-checkbox {
    font-weight: 800;
}

.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.second-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 0.8rem;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.field {
    padding: 0.2rem;
}
</style>
